import axios from '@/api/axios.config'

/**
 * Whether Lotus text boxes are offered for one funeral home (`allowed`), and
 * whether the limit is on (`limited`).
 */
export type LotusFuneralHomeAccess = { allowed: boolean; limited: boolean }

/** The limit that keeps Lotus text boxes to the funeral homes it lists. */
export type LotusFuneralHomeLimit = {
  enabled: boolean
  funeralHomes: Array<{ id: string; name: string }>
}

/** A change to the limit: each field left out stays as it is. */
export type LotusFuneralHomeLimitChange = {
  enabled?: boolean
  funeralHomeIds?: string[]
}

/**
 * Whether Lotus text boxes are offered for `funeralHomeId`: allowed while the
 * limit is off, or while it is on and lists the funeral home. Any signed-in
 * caller may ask.
 */
export const getLotusFuneralHomeAccess = async (funeralHomeId: string) =>
  await axios.get<LotusFuneralHomeAccess>('lotus/funeral-home-access', {
    params: { funeralHomeId },
  })

/** The limit and the funeral homes it lists. Super admins only. */
export const getLotusFuneralHomeLimit = async () =>
  await axios.get<LotusFuneralHomeLimit>('admin/lotus-funeral-home-limit')

/**
 * Changes the limit and answers it as it now stands. `funeralHomeIds`
 * replaces the whole list. Super admins only.
 */
export const updateLotusFuneralHomeLimit = async (
  change: LotusFuneralHomeLimitChange,
) =>
  await axios.patch<LotusFuneralHomeLimit>(
    'admin/lotus-funeral-home-limit',
    change,
  )
